import { CourseAdoptionTable } from '../components/CourseAdoptionTable';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AIMSExpansionSection.module.css';

export function AIMSExpansionSection() {
  return (
    <SectionWrapper background="soft" data-testid="research-section-expansion">
      <div className={styles.section}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>WHERE THE RESEARCH GOES NEXT</p>
          <h2 className={styles.title}>AIMS is expanding to more courses.</h2>
          <p>
            Following the publication, UCLA&apos;s Teaching and Learning Center
            funded an expansion of the AIMS program to additional Physical
            Sciences and Life Sciences courses over two academic years. Faculty
            in chemistry and life sciences are now adapting the supplemental
            math materials to their own course contexts and embedding
            AI-generated hints in their homework on Kudu.
          </p>
          <p>
            The goal: increase use of these interventions specifically among
            students who could most benefit, and reduce DFW (D, F, Withdraw)
            rates and grade disparities across the science core.
          </p>
          <p>
            This is the part that matters for institutions evaluating Kudu. The
            research isn&apos;t a one-off; it&apos;s the foundation of an
            ongoing program.
          </p>
        </div>
        <CourseAdoptionTable />
      </div>
    </SectionWrapper>
  );
}
